import { useCallback } from "react";

export const useHandleError = () => {
    const handleError = useCallback((error: any) => {
        console.error(error);
    }, []);

    return { handleError };
};
